import { loadDataWithVersionCheck } from './versionManager';

export interface ResultsData {
  // The three sub-personality fields below are OPTIONAL as of 2026-08-20
  // (ClickUp 86bb0f9vz). New results never carry them — the sub-quiz is gone —
  // but results stored in localStorage before that date still do, and
  // `specificDominantCategory` is the key that resolves a pre-existing user's
  // workbook exercises. Do not delete them: that would strip the field on the
  // way through and silently empty an existing user's saved workbook.
  answers: number[];
  specificAnswers?: number[];
  categoryScores: Record<string, number>;
  specificCategoryScores?: Record<string, number>;
  dominantCategory: string;
  specificDominantCategory?: string;
  sfAccount?: string | null;
  quizId?: number;
  leadId?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  paymentConfirmed?: boolean;
}

export function getResultsDataFromStateOrStorage(state: any): ResultsData | null {
  // Prefer flattened state as the source of truth
  const fromState: ResultsData | null = state && typeof state === 'object' ? (state as ResultsData) : null;
  if (fromState && (fromState.dominantCategory || fromState.quizId)) {
    return fromState;
  }

  // Backward compatibility: accept nested historical shapes
  if (state && typeof state === 'object') {
    const legacyQuizResults = (state as any).quizResults as ResultsData | undefined;
    if (legacyQuizResults && (legacyQuizResults.dominantCategory || legacyQuizResults.quizId)) {
      return legacyQuizResults;
    }
    const legacySafeResults = (state as any).safeResultsData as ResultsData | undefined;
    if (legacySafeResults && (legacySafeResults.dominantCategory || legacySafeResults.quizId)) {
      return legacySafeResults;
    }
  }

  // Fallback to localStorage
  try {
    const stored = localStorage.getItem('mpay_resultsData');
    if (!stored) return null;
    let parsed = JSON.parse(stored);
    parsed = loadDataWithVersionCheck(parsed, 'localStorage');
    return parsed as ResultsData;
  } catch (e) {
    console.error('Failed to load results data from storage:', e);
    return null;
  }
}

